import React, { useState, useEffect } from 'react';
import Pagination from 'react-bootstrap/Pagination';

const Paginator = ({ callback, defaultPage, maxPages }) => {
    const [active, setActive] = useState(Number(defaultPage) || 1);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (defaultPage) setActive(Number(defaultPage));
    }, [defaultPage]);

    useEffect(() => {
        const temp_items = [];
        for (let number = 1; number <= maxPages; number++) {
            temp_items.push(
                <Pagination.Item
                    key={number}
                    active={number === active}
                    onClick={() => {
                        setActive(number);
                        // console.log(number);
                        if (callback && typeof callback === 'function') callback(number);
                    }}
                >
                    {number}
                </Pagination.Item>,
            );
        }
        setItems(temp_items);
    }, [active, callback, maxPages]);
    return (
        <Pagination className="d-flex flex-wrap" size="sm">
            {items}
        </Pagination>
    );
};

export default Paginator;
